import { AlertTriangleIcon } from "apps/portal/src/components/atoms";
import { ReactNode } from "react";

type WarningSectionProps = {
  label: string;
  subLabel: string | ReactNode;
};

export const WarningSection = ({ label, subLabel }: WarningSectionProps) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-center gap-2">
      <div className="bg-warning-100 border-warning-50 dark:border-warning-900 dark:bg-warning-800 rounded-full border-4 p-1">
        <AlertTriangleIcon
          className="h-4 w-4"
          pathClassName="stroke-warning-600 dark:stroke-warning-200"
        />
      </div>
      <div className="dark:text-gray-25 text-base font-semibold text-gray-950">
        {label}
      </div>
    </div>
    <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
      {subLabel}
    </div>
  </div>
);
